import React from "react";
import Header from "../../shared/Header";
import { useAppSelector } from "../../../redux/ReduxType";
import LeftSideBar from "../common/LeftSideBar";
import RightSideBar from "../common/RightSideBar";

interface IFeedLayout {
  children: React.ReactNode;
}

const FeedTemplate: React.FC<IFeedLayout> = ({ children }) => {
  const isDark = useAppSelector((state) => state.theme.isDark);

  const handleMenu = (path: string) => {
    // Placeholder for menu navigation logic
  };

  return (
    <div
      className={`min-h-screen flex flex-col ${
        isDark ? "bg-deepBg text-white" : "bg-gray-100 text-gray-900"
      } transition-all duration-300 custom-scrollbar`}
    >
      <Header />
      <div className={`sm:grid sm:grid-cols-5 sm:gap-3 sm:px-4 px-0 py-3`}>
        {/* Left Sidebar */}
        <aside className={``}>
          <LeftSideBar isDark={isDark} currentSelection="/" menu={handleMenu} />
        </aside>

        {/* Main Content */}
        <main className={`col-span-3 overflow-auto`}>{children}</main>

        {/* Right Sidebar */}
        <aside className={``}>
          <RightSideBar />
        </aside>
      </div>
    </div>
  );
};

export default FeedTemplate;
